import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ToasterTypes } from 'src/app/core/enum/toaster-type.enum';
import { InvoiceService } from 'src/app/data/service/invoice.service';
import { ToasterMessageService } from 'src/app/shared/toaster-message/toaster-message.service';
import { Pannels } from '../enums/sidebar-pannels';
import { Invoice } from '../models/invoice/invoice';
import { RecognizedInvoiceService } from '../services/recognized-invoice.service';
import { SharedService } from '../services/shared-service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-add-new-invoice-page',
  templateUrl: './add-new-invoice-page.component.html',
  styleUrls: ['./add-new-invoice-page.component.scss']
})
export class AddNewInvoicePageComponent implements OnInit, OnChanges {
  isEditMode: boolean = true;
  isActionBarShown: boolean = true;
  isHorizontalDirection: boolean = false;
  loading: boolean = false;
  hexColorClass: string = "";
  submissionMethod: number = 1;
  // Whether the loaded bill has a scanned document. Starts true so the preview
  // mounts (and subscribes) during load; set from the invoice's pdfUrl after it
  // arrives, which collapses the empty preview column when there's no document.
  hasDocument: boolean = true;
  @Input() currentPannel: Pannels;

  // Embedded mode: the inbox renders this same detail as an in-page overlay
  // (query-param `id`) inside the compact cd_sidebar drawer, instead of the
  // full-page editInvoice/viewInvoice route. Edit vs View follows the row's
  // status the same way the routes did (For Review = editable, Processed = view).
  @Input() isEmbedded: boolean = false;
  @Input() invoiceId: string;
  @Input() embeddedEditMode: boolean = true;
  @Output() closed = new EventEmitter<void>();
  // Prev/next arrows inside the overlay — re-emitted from the form so the host
  // can swap the bill in place and update the `id` query param.
  @Output() navigateInvoice = new EventEmitter<{ id: string; editMode: boolean }>();
  // Tells the host whether the bill has a document, so the overlay panel can
  // size to the document+form split or shrink to the form when there's none.
  @Output() hasDocumentChange = new EventEmitter<boolean>();
  /** Relays the deleted invoice's id up from the form; see its emitter for why it must be carried. */
  @Output() onDeleteDocument = new EventEmitter<string>();
  // Re-emitted from the form: a bill was published, so the host can remove it
  // from the inbox table behind the overlay (it is no longer "For Review").
  @Output() invoicePublished = new EventEmitter<string>();
  /** A field change was saved in the form; the invoice as it now stands. */
  @Output() invoiceSaved = new EventEmitter<Invoice>();
  
  isMobileDevice = false;
  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _invoiceService: InvoiceService,
    private _toasterMessageService: ToasterMessageService,
    private _recognizedInvoiceService: RecognizedInvoiceService,
    private sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.checkIfMobileDevice();
    this._checkEditMode();
    this._getInvoice();
    this.openSideBarForNote();
  }

  /** The document viewer reported no fetchable file — collapse to form-only. */
  onDocumentUnavailable(): void {
    if (!this.isEmbedded) {
      return;
    }
    this.hasDocument = false;
    this.hasDocumentChange.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    // In the inbox overlay the component can stay mounted while the selected
    // bill changes — reload when the id changes.
    if (this.isEmbedded && changes.invoiceId && !changes.invoiceId.firstChange) {
      this._checkEditMode();
      this._getInvoice();
    }
  }

  checkIfMobileDevice() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || environment.isOutlookEnv || environment.isChromeEnv) {
      // true for mobile device
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }
  openSideBarForNote() {
    let recordId = this._route.snapshot.queryParamMap?.get('recordId');

    if (recordId) {
      this.currentPannel = Pannels.ActivityTab;
    }
  }
  // subsribeToSupplierEvents (){
  //   this.sharedService.isVisibleSource.subscribe((isVisible) => {
  //     this.isActionBarShown = isVisible;
  //   });
  // }

  updateColumnDirection() {
    this.isHorizontalDirection = !this.isHorizontalDirection;
    this.toggleActionBar();
  }

  toggleActionBar() {
    this.isActionBarShown = !this.isActionBarShown;
  }
  toggleInvoiceSideBar() {
    if (this.isEmbedded) {
      this.closed.emit();
      return;
    }
    this._router.navigate(['/inbox'], { replaceUrl: true })
  }

  private _checkEditMode() {
    // Embedded: For Review opens editable, Processed opens read-only — the host
    // passes this in (same edit/view split the routes used).
    if (this.isEmbedded) {
      this.isEditMode = this.embeddedEditMode;
      return;
    }
    if (this._router.url.includes('viewInvoice'))
      this.isEditMode = false;
  }

  private _getInvoice() {
    const id = this.isEmbedded ? this.invoiceId : this._route.snapshot.params?.id;

    if (id) {
      this.loading = true;
      // Re-mount the preview while the next bill loads (it subscribes on init).
      this.hasDocument = true;
      this.hasDocumentChange.emit(true);

      this._invoiceService.getInvoiceById(id)
        .pipe(take(1))
        .subscribe(
          (invoice: Invoice) => {
            this._recognizedInvoiceService.sendExistingInvoice(invoice);
            this.loading = false;
            this.hexColorClass = invoice.hexColorClass;
            this.submissionMethod = invoice.submissionMethod;
            this.hasDocument = !!invoice.pdfUrl;
            this.hasDocumentChange.emit(this.hasDocument);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', e.message);
          }
        )
    }
  }

}
